const baseUrl = 'https://home.homekeepr.com/blog';

/**
 * @param {string} [agentSlug]
 * @returns {string}
 */
export function getAgentBlogScript(agentSlug) {
	if (!agentSlug) {
		return '';
	}

	const blogURL = new URL(`${baseUrl}/assets/dist/homekeepr-blog.min.js`);

	const script = document.createElement('script');
	script.setAttribute('src', blogURL.toString());
	script.setAttribute('type', 'text/javascript');

	const div = document.createElement('div');
	div.setAttribute('data-sharedby', agentSlug);
	div.setAttribute('class', 'homekeepr-blog');

	return `${script.outerHTML}\n${div.outerHTML}`;
}

/**
 * @param {string} [agentSlug]
 * @returns {string}
 */
export function getAgentIframe(agentSlug) {
	if (!agentSlug) {
		return '';
	}

	const blogURL = new URL(baseUrl);

	const height = '650';

	blogURL.searchParams.append('sharedby', agentSlug);

	const iframe = document.createElement('iframe');
	iframe.setAttribute('height', height);
	iframe.setAttribute('src', blogURL.toString());
	iframe.setAttribute('width', '100%');
	iframe.setAttribute(
		'style',
		`border:none; height: ${height}px; width: 100%`
	);

	return iframe.outerHTML.replace(/&amp;/g, '&');
}
